<div class="response table-responsive m-b-2">
    <table class="est-table building-table" cellspacing="0">
        <thead>
            <th>Property Uid</th>
            <th>Floor Number</th>
            <th>Floor Type</th>
            <th>Floor Uid</th>
            <th>Parking Covered Parking Value</th>
            <th>Parking Open Parking Value</th>
            <th>Parking Shaded Parking Value</th>
            <th>Parking Covered Floor Area (sqm)</th>
            <th>Parking Open Floor Area (sqm)</th>
            <th>Parking Shaded Floor Area (sqm)</th>
            <th>Floor Name</th>
            <th>Parking Covered Parking Area (sqm)</th>
            <th>Parking Open Parking Area (sqm)</th>
            <th>Parking Shaded Parking Area (sqm)</th>

        </thead>
        <tbody>
            @for (item of tableData; track $index) {
                <tr>
                <td>{{item.property_uid || '-'}}</td>
                <td>{{item.floor_number || '-'}}</td>
                <td>{{item.floor_type || '-'}}</td>
                <td>{{item.floor_uid || '-'}}</td>
                <td>{{item.parking_covered_parking_value ? (item.parking_covered_parking_value | number : '1.0-1') : '-'}}</td>
                <td>{{item.parking_open_parking_value ? (item.parking_open_parking_value | number : '1.0-1') : '-'}}</td>
                <td>{{item.parking_shaded_parking_value ? (item.parking_shaded_parking_value | number : '1.0-1') : '-'}}</td>
                <td>{{item.parking_covered_floor_area ? (item.parking_covered_floor_area | number : '1.0-1') : '-'}}</td>
                <td>{{item.parking_open_floor_area ? (item.parking_open_floor_area | number : '1.0-1') : '-'}}</td>
                <td>{{item.parking_shaded_floor_area ? (item.parking_shaded_floor_area | number : '1.0-1') : '-'}}</td>
                <td>{{item.floor_name || '-'}}</td>
                <td>{{item.parking_covered_parking_area ? (item.parking_covered_parking_area | number : '1.0-1') : '-'}}</td>
                <td>{{item.parking_open_parking_area ? (item.parking_open_parking_area | number : '1.0-1') : '-'}}</td>
                <td>{{item.parking_shaded_parking_area ? (item.parking_shaded_parking_area | number : '1.0-1') : '-'}}</td>
                </tr>
                }
        </tbody>
    </table>

</div>
<div>
    @if(response){
        <app-table-pagination [tableData]="response" [itemsPerPage]="10" (filterData)="updateRecord($event)"></app-table-pagination>
    }
</div>
